import React from "react";
import Hero from "../components/Hero";
import { WhyUs, Platforms, HowItWorks, Compare, Testimonials, FAQ } from "../components/HomeSections";
import LeadForm from "../components/LeadForm";

export default function HomePage() {
  return (
    <>
      <Hero />
      <WhyUs />
      <Platforms />
      <HowItWorks />
      <Compare />
      <Testimonials />
      <FAQ />
      <section id="get-started" className="py-20 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Get started</div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B2447] tracking-tight">Take control of your reputation today</h2>
            <p className="mt-4 text-slate-600 leading-relaxed">Tell us what's hurting you and get a free, no-obligation assessment. Remember: if we can't remove it, you don't pay.</p>
            <ul className="mt-8 space-y-3 text-sm text-slate-700">
              {["Free analysis of your content", "No upfront fees, ever", "A response from a real specialist, fast", "5,000+ brands already protected"].map((x) => (
                <li key={x} className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-emerald-500" /> {x}</li>
              ))}
            </ul>
          </div>
          <LeadForm />
        </div>
      </section>
    </>
  );
}
